<template>
    <v-chip :color="color" readonly outline small disabled>
        <v-icon size="15" class="mr-2">{{icon}}</v-icon>
        {{eventStatus.name}}
    </v-chip>
</template>

<script>
    import {getStatusColor} from '@/utils/ScheduleEvent'
    export default{
        props: ['eventStatus'],
        computed: {
            color(){
                return getStatusColor(this.eventStatus.id)
            },
            icon(){
                switch(this.eventStatus.id){
                    case 1:
                        return 'fas fa-info-circle'
                        break
                    case 2:
                        return 'fas fa-check-circle'
                        break
                    case 3:
                        return 'fas fa-hourglass-half'
                        break
                    case 4:
                        return 'fas fa-hourglass-half'
                        break
                    default:
                        return 'fas fa-check-circle'
                        break
                }
            }
        }
    }
</script>